<template>
  <v-row class="campos">
    <v-col cols="12" md="8">
      <ValidationProvider name="Nome completo" rules="required|max:160" v-slot="{ errors }">
        <e-label>Nome completo do aluno</e-label>
        <v-text-field v-model="dados.nome" :error-messages="errors" counter="160" dense solo />
      </ValidationProvider>
    </v-col>
    <v-col cols="12" md="4">
      <ValidationProvider name="Gênero" rules="required" v-slot="{ errors }">
        <e-label>Gênero</e-label>
        <v-select
          v-model="dados.sexo_id"
          :items="sexos"
          item-text="descricao"
          item-value="id"
          :error-messages="errors"
          dense
          solo
        />
      </ValidationProvider>
    </v-col>
    <v-col cols="12" md="6">
      <ValidationProvider name="Filiação 1" rules="required|max:160" v-slot="{ errors }">
        <e-label>Filiação 1</e-label>
        <v-text-field v-model="dados.filiacao_1" :error-messages="errors" dense solo />
      </ValidationProvider>
    </v-col>
    <v-col cols="12" md="6">
      <ValidationProvider name="Filiação 2" rules="max:160" v-slot="{ errors }">
        <e-label>Filiação 2 (opcional)</e-label>
        <v-text-field v-model="dados.filiacao_2" :error-messages="errors" dense solo />
      </ValidationProvider>
    </v-col>
    <v-col cols="12" md="4">
      <ValidationProvider name="Cor/raça" rules="required" v-slot="{ errors }">
        <e-label>Cor/raça</e-label>
        <v-select
          v-model="dados.cor_raca"
          :items="$constants.corOuRacaList"
          :error-messages="errors"
          dense
          solo
        />
      </ValidationProvider>
    </v-col>
    <v-col cols="12" md="4">
      <ValidationProvider name="País de nacionalidade" rules="required" v-slot="{ errors }">
        <e-label>País de nacionalidade</e-label>
        <v-select
          v-model="nacionalidade"
          :items="$constants.paisesNascimento"
          :error-messages="errors"
          dense
          solo
        />
      </ValidationProvider>
    </v-col>
    <v-col v-if="nacionalidade === OUTRA_NACIONALIDADE" cols="12" md="4">
      <ValidationProvider name="País" rules="required|max:160" v-slot="{ errors }">
        <e-label>Qual país?</e-label>
        <v-text-field v-model="dados.pais" :error-messages="errors" dense solo />
      </ValidationProvider>
    </v-col>
    <v-col cols="12" md="4">
      <ValidationProvider name="UF de nascimento" rules="required" v-slot="{ errors }">
        <e-label>UF de nascimento</e-label>
        <v-select
          v-model="dados.uf_id"
          :items="estados"
          item-text="sigla"
          item-value="id"
          :error-messages="errors"
          dense
          solo
        />
      </ValidationProvider>
    </v-col>
    <v-col cols="12" md="8">
      <ValidationProvider
        name="Município de nascimento"
        rules="required|max:100"
        v-slot="{ errors }"
      >
        <e-label>Município de nascimento</e-label>
        <v-autocomplete
          v-model="dados.cidade_nascimento"
          :items="municipios"
          :disabled="!dados.uf_id"
          :error-messages="errors"
          no-data-text="Nenhum município encontrado"
          dense
          solo
        />
      </ValidationProvider>
    </v-col>
    <v-col cols="12">
      <p class="subtitle-2 mb-0">Endereço do aluno</p>
      <e-endereco-pre-matricula :dados="dados" prefixo="endereco_" />
    </v-col>
  </v-row>
</template>

<script>
import EEnderecoPreMatricula from "./EEnderecoPreMatricula.vue";
import { mensagemDeErro } from "./helpers";

const BRASIL = "Brasil";
const OUTRA_NACIONALIDADE = "Outra Nacionalidade";

/**
 * Dados do aluno, só no formulário completo (CPF sem cadastro).
 *
 * País usa a mesma lista do cadastro de aluno ($constants.paisesNascimento). `pais` guarda "Brasil"
 * ou o nome do país estrangeiro digitado; a efetivação converte para nacionalidade e
 * outroPaisNascimento do aluno.
 */
export default {
  name: "EDadosDoAluno",
  components: { EEnderecoPreMatricula },
  props: {
    dados: { type: Object, required: true },
  },
  data() {
    let nacionalidade = null;
    if (this.dados.pais) nacionalidade = this.dados.pais === BRASIL ? BRASIL : OUTRA_NACIONALIDADE;
    return { sexos: [], estados: [], nacionalidade, OUTRA_NACIONALIDADE };
  },
  computed: {
    municipios() {
      const estado = this.estados.find((item) => item.id === this.dados.uf_id);
      const lista = estado && this.$constants.municipios[estado.sigla];
      return lista ? lista.cidades : [];
    },
  },
  watch: {
    nacionalidade(valor) {
      this.dados.pais = valor === BRASIL ? BRASIL : null;
    },
    "dados.uf_id": function aoTrocarUf() {
      this.dados.cidade_nascimento = null;
    },
  },
  async mounted() {
    try {
      const servico = this.$services.preMatriculasService;
      [this.sexos, this.estados] = await Promise.all([servico.sexos(), servico.estados()]);
    } catch (error) {
      this.$emit("erro", mensagemDeErro(error));
    }
  },
};
</script>
